<h1 mat-dialog-title class="mbp-confirm-dialog__title">Confirm your details</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content">
  <p class="mbp-confirm-dialog__message">Please check all your details are correct</p>
</div>
<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button data-testid="cancel-button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button data-testid="confirm-button" mat-flat-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>Confirm</button>
</div>
